import { Dispatch, SetStateAction } from 'react';
import restart from '../../../../../../../../assets/images/icons/restart.svg';

interface TitleInterface {
  hasOriginalEmailsChanged: boolean;
  resetEmails: () => void;
  addImage: string;
  setAddEmailModalShow: Dispatch<SetStateAction<boolean>>;
  titleLabel: string;
}

export default function Title({
  hasOriginalEmailsChanged,
  resetEmails,
  addImage,
  setAddEmailModalShow,
  titleLabel,
}: TitleInterface) {
  return (
    <div className="card-title">
      <div>
        {titleLabel}
      </div>
      <div className="actions">
        {hasOriginalEmailsChanged && (
          <img
            src={restart}
            alt="add"
            className="primaryColor"
            title="Desfazer ações"
            onClick={() => resetEmails()}
          />
        )}
        <img
          src={addImage}
          alt="add"
          className="primaryColor"
          title="Desabilitar nova data"
          onClick={() => setAddEmailModalShow(true)}
        />
      </div>
    </div>
  );
}
